import { DateTime } from 'luxon';

export const fromISOtoISODate = (isoDate: string) => {
  return DateTime.fromISO(isoDate).setLocale('ru').toISODate() ?? '';
};
